import { internalPermanentDirect } from '@libs/common-next';

export const handleProductNotFoundRedirect = (slugs: string[]) => {
    console.info(`[PDP] Logical Redirect: PDP did not return a valid product.`);

    const parentCategory = slugs?.slice(0, slugs.length - 1).join('/');

    // Attempt to redirect to primary category page
    if (parentCategory) {
        internalPermanentDirect(`/${parentCategory}`);
    }

    // If no parent category can be determined from URL, redirect to homepage
    internalPermanentDirect('/');
};
